import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearModelsBrandActions, getModelsBrand } from '../../redux/actions/modelsActions';

const useFetchModelsBrand = (brandId) => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.models.brandLoading);
  const brand = useSelector((state) => state.models.brand);

  const fetchRoles = useCallback(async () => {
    await dispatch(getModelsBrand(brandId));
  }, [brandId, dispatch]);

  useEffect(() => {
    fetchRoles();
  }, [fetchRoles]);

  useEffect(() => {
    return () => {
      dispatch(clearModelsBrandActions());
    };
  }, [dispatch]);

  return { brand, loading };
};

export default useFetchModelsBrand;
